import { fromJS } from 'immutable';

import {
    EMPTY_PLANT_OPTIONS,
    HIDE_IMAGE,
    IS_IMAGE_LOADING,
    REMOVE_PLANT_OPTIONS,
    SAVE_PLANT_OPTIONS,
    SHOW_IMAGE,
} from '../constants/actions';

export function miscellaneousReducer(state = fromJS({}), action) {
    switch (action.type) {
        case SAVE_PLANT_OPTIONS:
            let plantOptions: Array<Object> = state.get('plantOptions') || [];
            return state.set('plantOptions', plantOptions.concat(action.plantOptions));
        case REMOVE_PLANT_OPTIONS:
            let newPlantOptions: Array<any> = state.get('plantOptions') || [];
            const plants = newPlantOptions.filter(val => action.region !== val.Plant_Region);
            return state.set('plantOptions', plants);
        case EMPTY_PLANT_OPTIONS:
            return state.set('plantOptions', []);
        case SHOW_IMAGE:
            return state.set('imageURL', action.imageURL);
        case HIDE_IMAGE:
            return state.set('imageURL', '');
        case IS_IMAGE_LOADING:
            return state.set('isImageLoading', action.isLoading);
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/reducers/miscellaneousReducer.ts